var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomewhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88878 13.1413V11.0009C4.88878 10.4545 5.35844 10.0116 5.93779 10.0116H8.05561C8.33382 10.0116 8.60064 10.1158 8.79737 10.3014C8.9941 10.4869 9.10462 10.7385 9.10462 11.0009V13.1413C9.10286 13.3685 9.19731 13.5869 9.36701 13.7481C9.53671 13.9093 9.76761 14 10.0085 14H11.4533C12.1282 14.0016 12.7759 13.75 13.2537 13.3006C13.7315 12.8511 14 12.2409 14 11.6045V5.5068C14 4.99272 13.7584 4.50509 13.3402 4.17527L8.42507 0.473108C7.57007 -0.176007 6.34503 -0.155049 5.51555 0.522885L0.712535 4.17527C0.274651 4.49537 0.0129333 4.98445 0 5.5068V11.5983C0 12.9247 1.14018 14 2.54665 14H3.95853C4.4588 14 4.86537 13.6194 4.86899 13.1476L4.88878 13.1413Z",
    fill: "#E0E0E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomewhite);
export default __webpack_public_path__ + "static/media/homewhite.8829a34411726de46e5a37e1b33337d0.svg";
export { ForwardRef as ReactComponent };